import React from "react";
import { Box, Loader, Text } from "rizzui";
import DrawerHeader from "./drawerHeader";
import CallRecording from "../../component/recording";
import formatDate from "../../lib/utils/formatDate";
import { useCallDetails } from "../../hooks/useCallDetails";

export default function RightDrawer({ onClose, row, location }) {
  const text = {
    calls: "Call details",
    leads: "Leads details",
    dashboard: "Call details",
  };

  const { isLoading, data, error } = useCallDetails({
    id: row?.original?._id,
    location: location,
  });

  const details =
    location === "calls" ? (
      <div className="flex flex-col gap-[11px]">
        <Text className="font-switzer text-center font-[500] text-[18px] leading-[23.76px]">
          {row?.original?.lead_details?.firstname}
        </Text>
        <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
          {row?.original?.phone_number}
        </Text>
      </div>
    ) : location === "leads" ? (
      <div className="flex flex-col gap-[11px]">
        <Text className="font-switzer text-center font-[500] text-[18px] leading-[23.76px]">
          {`${row?.original?.firstname} ${row?.original?.lastname}`}
        </Text>
        <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
          {row?.original?.email}
        </Text>
        <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
          {row?.original?.phone_number}
        </Text>
        <Text className="font-switzer text-center font-[400] text-[14px] leading-[15.84px]">
          {row?.original?.company_name}
        </Text>
      </div>
    ) : (
      ""
    );

  const activityDetails =
    location === "calls" || location === "dashboard" ? (
      <Box className="w-full flex flex-col gap-[24px]">
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Date & time called
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            {isLoading ? (
              <Loader variant="threeDot" />
            ) : (
              <span className="text-[#758599]">
                {formatDate(data?.updatedAt) || "--"}
              </span>
            )}
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Answered
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Status
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            {data?.call_status || "--"}
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Duration
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            {data?.call_duration_minutes || "--"}
          </Text>
        </div>

        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Cost
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            {data?.call_cost || "--"}
          </Text>
        </div>
      </Box>
    ) : location === "leads" ? (
      <Box className="w-full flex flex-col gap-[24px]">
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Date & time called
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Appointment date
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Answered
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Answered by
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Ended by
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Status
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
        <div className="flex flex-row justify-between">
          <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
            Duration
          </Text>
          <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
            --
          </Text>
        </div>
      </Box>
    ) : (
      ""
    );

  return (
    <>
      <div className="custom-scrollbar dark:bg-[#2A2C30] backdrop-blur-lg overflow-y-auto scroll-smooth h-full p-[20px]">
        <DrawerHeader
          status={row.original.is_active ? "booked" : "not booked"}
          onClose={onClose}
          location={location}
        />
        <div className="mt-[25px]">
          <div className="text-primary-dark flex flex-col gap-[32px]">
            <Text className="font-ibmPlexSerif text-[18px] leading-[23.4px] font-[600]">
              {" "}
              {text[location]}{" "}
            </Text>

            <Box className="w-full flex flex-col h-[168px] border-[.5px] dark:bg-[#333F48] dark:border-0 rounded-[8px] border-[#D9D9D9] justify-center place-items-center gap-[10px]">
              {location === "calls" && (
                <Box className="bg-[#D9D9D9] rounded-full h-[72px] w-[72px]" />
              )}
              {details}
            </Box>
            {activityDetails}
            <Box>
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px]">
                Call summary
              </Text>
              <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                {data?.call_summary ||
                  "The summary of the call will appear here once the call is completed."}
              </Text>
            </Box>

            <Box>
              <Text className="font-switzer font-[500] text-[14px] leading-[18.48px] mb-[16px]">
                Recording
              </Text>
              {data?.recording_url ? (
                <CallRecording recordingUrl={data?.recording_url} />
              ) : (
                <Text className="font-switzer font-[400] dark:text-[#758599] text-[12px] leading-[15.84px]">
                  The call recording will appear here.
                </Text>
              )}
            </Box>
          </div>
        </div>
      </div>
    </>
  );
}
